import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import VendorFormComponent from "./_form"

interface VendorForm {
  id: number
  company_name: string
  first_name: string
  last_name: string
  vendor_type_id: number | null
  country_id: number | null
  address: string
  address2: string
  city: string
  state: string
  zip: string
  office_phone: string
  cell_phone: string
  fax: string
  email: string
  website: string
  notes: string
  hourly_rate: number | null
  travel_rate: number | null
  mileage_rate: number | null
  schedule: boolean
}

interface Option {
  id: number
  name: string
}

interface Props {
  vendor: VendorForm
  vendor_types: Option[]
  countries: Option[]
  errors?: Record<string, string[]>
  group?: number | null
  group_name?: string | null
}

export default function Edit({
  vendor,
  vendor_types,
  countries,
  errors,
  group,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Subcontractors", href: "/company/vendors" },
    { title: "Edit Subcontractor", href: `/company/vendors/${vendor.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit Subcontractor" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Edit Subcontractor</h1>

        <VendorFormComponent
          vendor={vendor}
          vendor_types={vendor_types}
          countries={countries}
          errors={errors}
          submitUrl={`/company/vendors/${vendor.id}`}
          submitMethod="patch"
          group={group}
        />
      </div>
    </AppLayout>
  )
}
